<template>
  <div class="px-2">
    <div class="widget-12 card card-default widget-loader-circle shade mb-1">
      <div class="card-body">
        <div class="row">
          <div id="sources" class="col-md-4 col-sm-12 visible-md p-l-15">
            <div style="position: absolute; right: 0; z-index: 999" class="form-check form-check-inline switch m-t-20">
              <input type="checkbox" v-model="show_grafik_pie" id="pie-sources" />
              <label for="pie-sources">Tampilkan Grafik</label>
            </div>
            <div v-if="data_chart === null">
              <div class="pull-left">
                <div class="m-b-20" style="margin-top: 0.75rem">
                  <h4 class="m-b-0">Sumber</h4>
                  <p class="small hint-text">
                    Menampilkan jumlah postingan salurab per sumber
                  </p>
                </div>
              </div>
              <div class="clearfix" />
              <loader-component />
            </div>

            <div v-else>
              <div v-if="!sourceList()">
                <div class="pull-left">
                  <div class="m-b-20" style="margin-top: 0.75rem">
                    <h4 class="m-b-0">Sumber</h4>
                    <p class="small hint-text">
                      Menampilkan jumlah Mentions per sumber
                    </p>
                  </div>
                </div>
                <div class="clearfix" />
                <div class="alert alert-danger" id="errorApiEl" role="alert" align="center">
                  <strong>Mohon maaf, data tidak tersedia! </strong>
                  <br />
                  Tidak dapat menampilkan grafik dengan data kosong.
                </div>
              </div>
              <div v-else>
                <sources-list-component v-if="!show_grafik_pie" title="Sumber"
                  subTitle="Menampilkan jumlah Mentions per sumber" :lists="sources" />
                <div v-else>
                  <div class="pull-left">
                    <div class="m-b-20" style="margin-top: 0.75rem">
                      <h4 class="m-b-0">Sumber</h4>
                      <p class="small hint-text">
                        Menampilkan jumlah Mentions per sumber
                      </p>
                    </div>
                  </div>
                  <div class="clearfix" />
                  <div>
                    <pie-chart-component :data="data_pie" :config="config_pie" :height="380" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="tren-sources" class="col-md-8 col-sm-12">
            <div class="pull-left">
              <div class="m-b-20">
                <h4 class="m-b-0">Grafik Tren Mentions Berdasarkan Sumber</h4>
                <p class="small hint-text">
                  Grafik Tren Mentions Berdasarkan Sumber
                </p>
              </div>
            </div>
            <div class="pull-right">
              <div class="form-check form-check-inline switch m-t-20 m-b-0">
                <input type="checkbox" v-model="show_grafik_source" id="barchart-source" />
                <label for="barchart-source">Tampilkan Grafik Bar</label>
              </div>
            </div>
            <div class="clearfix" />

            <loader-component v-if="data_chart === null" />
            <div v-else-if="!sourceList()" class="alert alert-danger" id="errorApiEl" role="alert" align="center">
              <strong>Mohon maaf, data tidak tersedia! </strong>
              <br />
              Tidak dapat menampilkan grafik dengan data kosong.
            </div>
            <div v-else>
              <line-chart-component v-if="!show_grafik_source" :series="data_chart" el="linechart-sources"
                mode="single" />
              <div v-else>
                <bar-chart-component :data="data_chart" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import line_chart from "@/views/components/chart/line_chart.vue";
import pie_chart from "@/views/components/chart/pie_chart.vue";
import bar_chart_horizontal from "@/views/components/chart/bar_chart_horizontal.vue";
import source_list from "@/views/components/source_list.vue";
import loader_component from "@/views/components/loader.vue";

export default {
  name: "medsos_tren_mention_sources",
  components: {
    "line-chart-component": line_chart,
    "bar-chart-component": bar_chart_horizontal,
    "pie-chart-component": pie_chart,
    "sources-list-component": source_list,
    "loader-component": loader_component,
  },
  props: {
    data: Object,
    stats: Array,
  },
  data() {
    return {
      sources: this.stats,
      data_chart: this.data,
      show_grafik_source: false,
      show_grafik_pie: false,
      data_pie: [],
      config_pie: {
        align: "center",
        width: 300,
        itemWidth: 150,
      },
    };
  },
  methods: {
    assemblePieChart() {
      let color = [
        "#1da1f2",
        "#4267b2",
        "#e1306c",
        "#000000",
        "#dc3545",
        "#006192",
        "#6c757d",
        "#ffc107",
        "#3f3f3f",
      ];
      if (this.sourceList()) {
        for (let i = 0; i < this.sources.length; i++) {
          // if (this.sources[i].name == "Review Aplikasi") {
          //   this.sources[i].name = "Tinjauan Aplikasi";
          // }
          let source = this.sources[i].name;
          this.data_pie.push({
            color: color[i],
            name: this.sources[i].name,
            y: parseInt(this.sources[i].count),
            source: source.toLowerCase()
          });
        }
      }
    },
    sourceList() {
      if (this.sources) {
        for (let i = 0; i < this.sources.length; i++) {
          if (this.sources[i].count == "0") {
            return false;
          } else {
            return true;
          }
        }
      }
    },
  },
  created() {
    if (this.sources) {
      this.assemblePieChart();
    }
  },
};
</script>